// extracted by mini-css-extract-plugin
export default {"container":"TechGallery_container__nFDS3","topBar":"TechGallery_topBar__4KTD+"};